import { Box, Stack, Text } from '@chakra-ui/react'
import { identityCountryOptions, typeStatusOptions } from 'shared/constants/user'
import { Button, InputDate, InputSearch, Select } from 'uikit'
import { FilterFooter, FilterStack, FilterStackGroup } from 'uikit/layout'
import { ExportExcel } from './ExportExcel/ExportExcel'
import { identificationOptions, platformOptions, yesNoOptions } from './UserFilter.constants'

export const UserFilter = ({ value = {}, onChange, onReset, totalItems }) => {
  const handleFilter = (field) => {
    const fieldName = Object.keys(field)[0]
    const filedValue = field[fieldName]

    onChange({ ...value, [fieldName]: filedValue || undefined })
  }

  const handleResetFilter = () => {
    onChange({})
    onReset && onReset()
  }

  return (
    <>
      <FilterStack>
        <InputSearch
          hideIcon
          label="Фамилия"
          name="lastName"
          value={value.lastName}
          onChange={(e) => handleFilter({ lastName: e })}
        />
        <InputSearch
          hideIcon
          label="Имя"
          name="firstName"
          value={value.firstName}
          onChange={(e) => handleFilter({ firstName: e })}
        />
        <InputSearch
          hideIcon
          label="Отчество"
          name="middleName"
          value={value.middleName}
          onChange={(e) => handleFilter({ middleName: e })}
        />
        <InputSearch
          hideIcon
          label="Телефон"
          name="phone"
          value={value.phone}
          onChange={(e) => handleFilter({ phone: e })}
        />
        <InputSearch
          hideIcon
          label="Email"
          name="email"
          value={value.email}
          onChange={(e) => handleFilter({ email: e })}
        />
        <InputSearch
          hideIcon
          label="Client ID"
          name="clientId"
          value={value.clientId}
          onChange={(e) => handleFilter({ clientId: e })}
        />
        <Select
          name="identityCountry"
          label="Страна"
          isSearchable={false}
          placeholder="Выберите"
          value={value.identityCountry}
          options={identityCountryOptions}
          onChange={(e) => handleFilter({ identityCountry: e.value })}
          isClearable
        />
        <InputSearch
          hideIcon
          label="Номер паспорта"
          name="passportNumber"
          value={value.passportNumber}
          onChange={(e) => handleFilter({ passportNumber: e })}
        />
        <InputSearch
          hideIcon
          label="Номер договора"
          name="contractNumber"
          value={value.contractNumber}
          onChange={(e) => handleFilter({ contractNumber: e })}
        />
        <InputSearch
          hideIcon
          label="Номер счета"
          name="accountNumber"
          value={value.accountNumber}
          onChange={(e) => handleFilter({ accountNumber: e })}
        />
        <InputSearch
          hideIcon
          label="Версия"
          name="applicationVersion"
          placeholder="0.0.0"
          value={value.applicationVersion}
          onChange={(e) => handleFilter({ applicationVersion: e })}
        />
        <Select
          name="enabled"
          label="Статус"
          isSearchable={false}
          placeholder="Выберите"
          value={String(value.enabled)}
          options={typeStatusOptions}
          onChange={(e) => handleFilter({ enabled: e.value })}
          isClearable
        />
        <Select
          name="trusted"
          label="Снят лимит"
          isSearchable={false}
          placeholder="Выберите"
          value={value.trusted}
          options={yesNoOptions}
          onChange={(e) => handleFilter({ trusted: e.value })}
          isClearable
        />
        <Select
          name="inRkl"
          label="РКЛ"
          isSearchable={false}
          placeholder="Выберите"
          value={value.inRkl}
          options={yesNoOptions}
          onChange={(e) => handleFilter({ inRkl: e.value })}
          isClearable
        />
        <Select
          name="identification"
          label="Идентификация"
          isSearchable={false}
          placeholder="Выберите"
          value={value.identification}
          options={identificationOptions}
          onChange={(e) => handleFilter({ identification: e.value })}
        />
        <Select
          name="isIDXApproved"
          label="Идентификация по IDX"
          isSearchable={false}
          placeholder="Выберите"
          value={value.isIDXApproved}
          options={yesNoOptions}
          onChange={(e) => handleFilter({ isIDXApproved: e.value })}
          isClearable
        />
        <Select
          name="platform"
          label="Платформа"
          isSearchable={false}
          placeholder="Выберите"
          value={value.platform}
          options={platformOptions}
          onChange={(e) => handleFilter({ platform: e.value })}
        />

        <FilterStackGroup>
          <InputDate
            value={value.identificationDateFrom}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="identificationDateFrom"
            placement="bottom"
            onChange={(e) => handleFilter({ identificationDateFrom: e })}
            label="Дата идентификации"
            placeholder="C"
          />
          <InputDate
            value={value.identificationDateTo}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="identificationDateTo"
            placement="bottom"
            onChange={(e) => handleFilter({ identificationDateTo: e })}
            placeholder="По"
          />
        </FilterStackGroup>
        <FilterStackGroup>
          <InputDate
            value={value.registrationDateFrom}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="registrationDateFrom"
            placement="bottom"
            onChange={(e) => handleFilter({ registrationDateFrom: e })}
            label="Дата регистрации"
            placeholder="C"
          />
          <InputDate
            value={value.registrationDateTo}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="registrationDateTo"
            placement="bottom"
            onChange={(e) => handleFilter({ registrationDateTo: e })}
            placeholder="По"
          />
        </FilterStackGroup>
      </FilterStack>
      <FilterFooter pb="10px">
        <Stack gap={2} width="100%">
          <ExportExcel size={totalItems} />
          <Box>
            <Button size="sm" width="100%" onClick={handleResetFilter}>
              Очистить фильтр
            </Button>
            <Text
              fontSize="0.8rem"
              color="gray.300"
              mt={2}
              textAlign="center"
            >{`Найдено: ${totalItems}`}</Text>
          </Box>
        </Stack>
      </FilterFooter>
    </>
  )
}
